import React, { useState } from 'react'
import { Transition } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faRightFromBracket, faUser } from '@fortawesome/pro-light-svg-icons'
import { useHistory } from 'react-router-dom'
import { useCore, useLogin } from '../hooks'
import pckg from '../../package.json'

export const ProfileDropdown: React.FC = () => {
  const [profileDropdownOpen, setProfileDropdownOpen] = useState<boolean>(false)
  const { core } = useCore()
  const { handleLogout } = useLogin()
  const history = useHistory()

  return (
    <div className="relative flex items-center">
      <button
        className="flex items-center text-gray-600 focus:outline-none gap-3"
        onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}>
        <FontAwesomeIcon icon={faUser} className="w-5 h-5 p-2 rounded-full bg-cool-grey" />
        <span className="text-md">{core.services.oauth.session.email}</span>
        <FontAwesomeIcon icon={faChevronDown} className="text-md" />
      </button>

      <Transition
        show={profileDropdownOpen}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95">
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 top-full border border-gray-200">
          <div className="flex gap-2">
            <button
              onClick={() => handleLogout(() => history.push('/login'))}
              className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex-1">
              <FontAwesomeIcon icon={faRightFromBracket} className="mr-2" />
              Odhlásit se
            </button>
          </div>
          <div className="border-t border-gray-100 mt-1 pt-1">
            <div className="px-4 py-2 text-xs text-gray-500">Verze aplikace: {pckg.version}</div>
          </div>
        </div>
      </Transition>
    </div>
  )
}
